import { Component, OnInit, Inject } from '@angular/core';
import { IWindow } from '@phdsoft/window';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AutomaticPoints } from 'src/app/automatic-points/_models/AutomaticPoints';
import { GeneralSettings } from "src/app/automatic-points/_models/GeneralSettings"
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectionRegion } from "src/app/automatic-points/_models/InspectionRegion";
import { InspectionSession } from "src/app/automatic-points/_models/InspectionSession";
import { PointsArrangements } from "src/app/automatic-points/_models/PointsArrangements";
import { Util } from '@phdsoft/common';
import { SignalRService } from 'src/app/signalr/signalr';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import moment from 'moment';
@Component({
  selector: 'phdsoft-risk-inspection',
  templateUrl: './risk-inspection.component.html',
  styleUrls: ['./risk-inspection.component.scss']
})
export class RiskInspectionComponent implements OnInit {

  _AutomaticPoints: AutomaticPoints;
  favoriteSeason: string;
  _PointsArrangements: PointsArrangements;


  name1: String = "Teste";
  name2: String = "Teste2";

  LotRegion: boolean = true;

  LotSection: boolean = true;



  form: FormGroup;
  FormSession1FacePlates: FormGroup;

  optionsWindow: IWindow = {
    Position: 'top center',
    PositionMini: 'right',
    VisibleMini: false,
    //isMinimized: this.isMinimizePW,
    Header: {
      Icon: 'info',
      VisibleTitle: true,
      Title: 'Automatic - Risk Inspection'
    },
    Footer: {
      Visible: true,
    }
  };

  responsiveOptions;

  constructor(@Inject(MAT_DIALOG_DATA)
  public data: any,
  private fb: FormBuilder,
  public dialog: MatDialog,
  public signalRService: SignalRService,
  public assetManager: AssetManager,
) {
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
      }
    ];
  }

  isShown: boolean = false;
  toggleShow() {
    this.isShown = !this.isShown;
    this.initializeComponentData();
  }

  initializeComponentData(){
    this._AutomaticPoints = new AutomaticPoints();
    this._AutomaticPoints.Id = null;
    this._AutomaticPoints.AssetId = this.data.AssetId;
    this._AutomaticPoints.CollectionId = null;
    this._AutomaticPoints.Label = "AutomaticPoints";

    this.favoriteSeason = 'Pattern'




    //#region "GENERAL SETTINGS"
    this._AutomaticPoints.GeneralSettings = new GeneralSettings();
    this._AutomaticPoints.GeneralSettings.CurrentPage = true;
    this._AutomaticPoints.GeneralSettings.AllPages = false;
    this._AutomaticPoints.GeneralSettings.BulkheadsNoStifffners = true;
    this._AutomaticPoints.GeneralSettings.DeleteOldAutomaticPoints = false;
    this._AutomaticPoints.GeneralSettings.Date = moment(this.assetManager.referenceDate).format("yyyy-MM-DD")

    this._AutomaticPoints.GeneralSettings.Regions = [];


    for (let i = 0; i <= this.data.regions.length - 1; i++) {
      let _Lst_SectionIds = [];

      var _ItemRegions = new InspectionRegion();
      _ItemRegions.RegionId = this.data.regions[i][0]; //"1";
      _ItemRegions.SectionIds = this.data.regions[i][2].map(x => x[0]);  //_ItemRegions.SectionsIds = ["teste", "teste2"];
      _ItemRegions.RegionName = this.data.regions[i][1];
      _ItemRegions.RegionChecked = !Util.isNullOrUndefined(this.data.regionsIds.find(x => x === this.data.regions[i][0]));
      if(!this.isShown){
        _ItemRegions.RegionChecked = true;
      }
      console.log(i)
      console.log(_ItemRegions)


      var _Info_Session = new InspectionSession();
      _ItemRegions.Sections = [];

      for (let j = 0; j <= this.data.regions[i][2].length - 1; j++) {
        // _Info_Session.SectionId = this.data.regions[i][2][j][0];
        // _Info_Session.SectionName = this.data.regions[i][2][j][1];
        // _Info_Session.SectionChecked = true;

        const sectionInfo = {
          SectionId: this.data.regions[i][2][j][0], SectionName: this.data.regions[i][2][j][1],
          SectionChecked: !Util.isNullOrUndefined(this.data.sectionIds.find(x => x === this.data.regions[i][2][j][0]))
        }
        if(!this.isShown){
          sectionInfo.SectionChecked = true;
        }

        _Lst_SectionIds.push(this.data.regions[i][2][j][0]);

        _ItemRegions.Sections.push(sectionInfo);
      }


      // var tranform = {
      //   name: _ItemRegions.RegionName,
      //   id: _ItemRegions.RegionId,
      //   selected: false,
      //   parentId: '',
      //   item: '',
      //   children: _ItemRegions.Sections.map(y => ({ name: y.SectionName, parentId: _ItemRegions.RegionId, selected: false, id: y.SectionId }))
      // }

      if(this.isShown){
        this._AutomaticPoints.GeneralSettings.Regions.push(this.tranform(_ItemRegions));
      }else{
        this._AutomaticPoints.GeneralSettings.Regions.push(_ItemRegions);
      }
    }



  }


  tranform = (region) => ({
    name: region.RegionName,
    id: region.RegionId,
    selected: false,
    parentId: '',
    item: '',
    children: region.Sections.map(y => ({ name: y.SectionName, parentId: region.RegionId, selected: false, id: y.SectionId }))
  })

  transformBack = (region) => ({
    SectionIds: region.SectionIds,
    RegionName: region.name,
    RegionId: region.id,
    RegionChecked: region.selected,
    Sections: region.children.map(x => ({ SectionName: x.name, SectionId: x.id, SectionChecked: x.selected }))

  })



  ngOnInit() {
    this.form = this.fb.group({
      role: []
    });

    this.FormSession1FacePlates = this.fb.group({
      role: []
    });

    this.initializeComponentData();
    // console.log(this.assetManager.referenceDate) da la hora actual
    console.log( this._AutomaticPoints.GeneralSettings.Date)

  }




  async submit() {
console.log()
  }

  Execute() {
    this.dialog.closeAll();
  }



  onSelectRegion({ regionId }) {



    //var newRegions = [];



    this._AutomaticPoints.GeneralSettings.Regions.forEach(element => {

      if (element.id === regionId) {

        var selected = !element.selected

        element.selected = selected

        element.children.forEach(s => {

          s.selected = selected


        });
        // var sections = element.children.map(x => ({ ...x, selected: !element.selected }));

        //   newRegions.push({ ...element, Sections: sections });
      }
      // else {
      //   newRegions.push(element)
      // }

    });

    //  this._AutomaticPoints.GeneralSettings.Regions = newRegions;

  }

  onSelectSection({ regionId, sectionId }) {



    this._AutomaticPoints.GeneralSettings.Regions.forEach(element => {

      if (element.id === regionId) {

        element.children.forEach(s => {

          if (s.id === sectionId) {
            s.selected = !Boolean(s.selected)
          }

        })

      }

    });
  }




}
